import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import * as CoreFrameDTOs from "coreframetypings/dto";
import { ITabStripTabViewModelConstructorParameter } from "#/DefaultViewExtensionInterfaces";

export default class TabStripTabViewModel extends ControlViewModel {

    /**
     * Der Kontext des ViewModels
     */
    public context: DetailViewContext;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Enthält die inneren DetailViewItems
     */
    public detailViewItems: Array<CoreFrameDTOs.IDVGItemDTO>;

    /**
     * Enthält die inneren DetailViewGroups
     */
    public detailViewGroups: Array<CoreFrameDTOs.IDetailViewGroupDTO>;

    /**
     * Das jQuery-Element welches den Tab-Content beinhaltet
     */
    public content: JQuery;

    /**
     * Ein Handler, der aufgerufen wird, bevor der Tab gewechselt wird
     */
    public onBeforeTabChange: ITabStripTabViewModelConstructorParameter['onBeforeTabChange'];

    /**
     * Gibt an, ob der TabStrip eine WizardGroup darstellt
     */
    public isWizard: boolean;

    /**
     * Enthält das Label
     */
    public label: LabelViewModel;

    public isRendered: KnockoutObservable<boolean>;

    /**
     * Das ViewModel für ein TabStripTab
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: ITabStripTabViewModelConstructorParameter) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.detailViewItems = this.paramOrDefault(params.detailViewItems, []);
        this.detailViewGroups = this.paramOrDefault(params.detailViewGroups, []);
        this.content = this.paramOrDefault(params.content, $());
        this.onBeforeTabChange = this.handlerOrDefault(params.onBeforeTabChange);
        this.isWizard = this.paramOrDefault(params.isWizard, false);
        this.label = this.paramOrDefault(params.label, null);
        this.isRendered = this.observableOrDefault(false);

        this.defineSubscription(this.isRendered, (isRendered) => {
            if (isRendered) {
                this.context.notifyPartialRendered();
            }
        });
    }
}

ComponentManager.setViewModel('TabStripTabViewModel', TabStripTabViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');